export default __webpack_public_path__ + "static/img/watch_clockbg.d2cf84e.png";